/**
 *
 * SideLayout
 *
 */

import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import {
  Layout,
  Menu
} from 'antd';
const { Sider } = Layout;

// assets
import CustomIcons from 'components/CustomIcons';

// components
import UserAvatar from 'components/UserAvatar';
// utils
import history, { parseQuery, encodeQueryData } from 'utils/history';
// global user
import { useGetLocalUser } from 'engine/Contexts/User.context';

// contexts
import { withTheme } from 'engine/Contexts/Theme.context';

function SideLayout({
  // actions
  onClick,
  // contexts
  theme,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('layout-side-menu', className);
  const localUser = useGetLocalUser()();
  const location = useLocation();
  const nameMenuSplit = location.pathname.split('/');
  const createdNew = !!location?.state?.isNew;
  const dafaultPath = `/${nameMenuSplit[1]}`;

  const [defaultActiveItem, setDefaultActiveItem] = useState(dafaultPath);
  const [tempActiveItem, setTempActiveItem] = useState(dafaultPath);

  useEffect(() => {
    const newPath = `/${nameMenuSplit[1]}`;
    if (newPath !== defaultActiveItem) {
      const redirectWithData = {
        pathname: newPath,
        search: '',
        hash: '',
        state: {
          preview: false,
          needRefresh: true,
        },
      };
      redirectWithData.state.from = defaultActiveItem.replace('/', '');
      history.push(redirectWithData);

      setDefaultActiveItem(newPath);
    }
  }, [location.pathname]);

  // check if we have some changes in the form, and we click outside of this form
  useEffect(() => {
    if (!!theme?.canceledModalOnSaveChanges) {
      if ( tempActiveItem !== defaultActiveItem) {
        const redirectWithData = {
          pathname: tempActiveItem,
          search: '',
          hash: '',
          state: {
            preview: false,
            needRefresh: true,
          },
        };
        redirectWithData.state.from = defaultActiveItem.replace('/', '');
        history.push(redirectWithData);
  
        setDefaultActiveItem(tempActiveItem);
      }
    }
  }, [theme?.canceledModalOnSaveChanges]);

  // INFO: For futore versions !!!
  const menuItems = [
    {
      key: '/home',
      icon: <CustomIcons className="home-cicon" type="home" />,
      label: 'Home',
      disabled: false,
    },
    {
      key: '/classes',
      icon: <CustomIcons className="classes-cicon" type="users" />,
      label: 'Classes',
      disabled: false,
    },
    {
      key: '/сours',
      icon: <CustomIcons className="cсours-cicon" type="book" />,
      label: 'Cours',
      disabled: false,
    },
    {
      key: '/absences',
      icon: <CustomIcons className="absences-cicon" type="absence" />,
      label: 'Absences',
      disabled: false,
    },
    {
      key: '/etudiants',
      icon: <CustomIcons className="etudiants-cicon" type="academic" />,
      label: 'Etudiants',
      disabled: false,
    },
    {
      key: '/utilisateurs',
      icon: (
        <CustomIcons
          className="utilisateurs-cicon"
          style={{ width: '20px' }}
          type="person"
        />
      ),
      label: 'Utilisateurs',
      disabled: false,
    },
    {
      key: '/rapports',
      icon: <CustomIcons className="rapports-cicon" type="document" />,
      label: 'Rapports',
      disabled: true,
    },
    {
      key: '/plans',
      icon: <CustomIcons className="plans-cicon" type="calendar" />,
      label: 'Plans',
      disabled: false,
    },
    {
      key: '/communications',
      icon: <CustomIcons className="news-cicon" type="letter-close" />,
      label: 'News',
      disabled: false,
    },
    {
      key: '/audiences',
      icon: <CustomIcons className="audiences-icon" type="group" />,
      label: 'Audiences',
      disabled: false,
    },
    {
      key: `/utilisateurs/${localUser?._id}`,
      icon: <UserAvatar width={24} height={24} />,
      label: 'Profile',
      disabled: false,
    },
  ];

  const menuItemsTeacher = [
    {
      key: '/home',
      icon: <CustomIcons className="home-cicon" type="home" />,
      label: 'Home',
      disabled: false,
    },
    {
      key: '/communications',
      icon: <CustomIcons className="news-cicon" type="letter-close" />,
      label: 'News',
      disabled: false,
    },
    {
      key: '/audiences',
      icon: <CustomIcons className="audiences-icon" type="group" />,
      label: 'Audiences',
      disabled: false,
    },
  ];

  const onClickMenuHandle = ({ key, keyPath, domEvent }) => {
    setTempActiveItem(key);
    const newPath = key;
    if (newPath !== defaultActiveItem && !!!theme?.hasValueModalOnSaveChanges) {
      const redirectWithData = {
        pathname: newPath,
        search: '',
        hash: '',
        state: {
          preview: false,
          needRefresh: true,
        },
      };
      redirectWithData.state.from = defaultActiveItem.replace('/', '');
      history.push(redirectWithData);

      setDefaultActiveItem(newPath);
    } 
  };

  const showOpenOnSaveModalCallback = useCallback(() => {
    theme?.onOpenOnSaveModalCallback() 
    !!onClick && onClick();
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges, onClick]);

  return (
    <Sider className={childClassNames} onClick={showOpenOnSaveModalCallback}>
      <Menu
        className="side-menu"
        theme="light"
        mode="vertical"
        items={localUser?.role == 'teacher' ? menuItemsTeacher : menuItems}
        defaultSelectedKeys={[dafaultPath]}
        selectedKeys={[defaultActiveItem]}
        activeKey={defaultActiveItem}
        onClick={onClickMenuHandle}
      />
    </Sider>
  );
}

SideLayout.propTypes = {};

export default withTheme(SideLayout);